export default "__VITE_ASSET__CtpeWQY5__"